export default "__VITE_ASSET__B5Ufy7mx__"